import React from "react";
import "../../../styles/main.css";
import PageHeader from "../../../components/reusable/ModuleHeader/PageHeader";
import Breadcrumb from "../../../components/reusable/ModuleHeader/Breadcrumb";


const Page51 = () => {
  return (
    <div style={{ padding: 4 }}>
      <Breadcrumb
        items={[
          { label: "Accueil", href: "/HomePage" },
          { label: "Tableau de bord", href: "/dashboard" },
        ]}
      />
      <PageHeader
        title="Overview"
        subtitle="Gérez les intéractions et les impacts de l'environnement du projet"
        className= "title-orbit"
      />
      {/* Contenu de la page */}
      
      
    </div>

  );
};

export default Page51;
